import React from 'react';

export default class ExperiencedTools extends React.Component {
  render () {
    return (
      <div className="tools">
        <h1 className="title-is-mark">{ this.props.tools.title }</h1>
          <ul>
            { this.props.tools.list.map((tool, index) => {
              return (
                <li key={ index }>{ tool }</li>
              )
            }) }
          </ul>
      </div>
    )
  }
}